module.exports = __webpack_public_path__ + "media/images/prev-transparent-b9f9a889ef9c070cf53da455fcc39cc7.svg";